module.exports = __webpack_public_path__ + "img/logo.f9c8dbc0.svg";